__turbopack_context__.v({
  "backdrop": "BgBlurredText-module__UlEbSG__backdrop",
  "config": "BgBlurredText-module__UlEbSG__config",
  "configContents": "BgBlurredText-module__UlEbSG__configContents",
  "content": "BgBlurredText-module__UlEbSG__content",
  "content1": "BgBlurredText-module__UlEbSG__content1",
  "content2": "BgBlurredText-module__UlEbSG__content2",
  "contentOne": "BgBlurredText-module__UlEbSG__contentOne",
  "contentTwo": "BgBlurredText-module__UlEbSG__contentTwo",
  "desktopBr": "BgBlurredText-module__UlEbSG__desktopBr",
  "imgContainer": "BgBlurredText-module__UlEbSG__imgContainer",
  "root": "BgBlurredText-module__UlEbSG__root",
});
